import { createSelector } from 'reselect';

const selectCargoLeads = (state: any) => state.cargoLeads;

export const selectCargoLeadsCurrentItem = createSelector([selectCargoLeads], (cargoLeads) => cargoLeads.current);

export const selectCargoLeadsListItems = createSelector([selectCargoLeads], (cargoLeads) => cargoLeads.list);

export const selectCargoLeadsItemById = (itemId: any) =>
    createSelector(selectCargoLeadsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectCargoLeadsQueryItems = createSelector([selectCargoLeads], (cargoLeads) => cargoLeads.query);

export const selectCargoLeadsCreatedItem = createSelector([selectCargoLeads], (cargoLeads) => cargoLeads.create);

export const selectCargoLeadsUpdatedItem = createSelector([selectCargoLeads], (cargoLeads) => cargoLeads.update);

export const selectCargoLeadsReadItem = createSelector([selectCargoLeads], (cargoLeads) => cargoLeads.read);

export const selectCargoLeadsDeletedItem = createSelector([selectCargoLeads], (cargoLeads) => cargoLeads.delete);

export const selectCargoLeadsSearchedItems = createSelector([selectCargoLeads], (cargoLeads) => cargoLeads.search);

export const selectCargoLeadsItemsCount = createSelector([selectCargoLeads], (cargoLeads) => cargoLeads.count);

export const selectCargoLeadsItemsFilter = createSelector([selectCargoLeads], (cargoLeads) => cargoLeads.filter);